import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import TopForm from '../../img/hrws_gall_6.jpg';
import YellowIcon from '../../img/yellow-icon.png';
import CircleList from '../../img/circle_list_1.png';

const EventThemesBase = ({ themesData }) => {

    if (!themesData) return null;

    const { theme_title, theme_subtitle, theme_list } = themesData;

    return (
        <section className="mb-20">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-2">
                <div className="flex justify-center lg:justify-end">
                    <div className="w-[90%] max-w-screen-sm relative">
                        {/*<ScrollAnimation animateIn="animate__fadeInUp">*/}
                        {/*    <h6 className="bg-[#F3FF80] w-max px-3 py-1 mb-4 rounded-2xl">{theme_subtitle}</h6>*/}
                        {/*</ScrollAnimation>*/}
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h2 className="sm:text-4xl text-2xl uppercase mb-6">{theme_title}</h2>
                        </ScrollAnimation>

                        {theme_list.map((theme, index) => (
                            <div className="mb-6 relative flex flex-wrap gap-3">
                                <ScrollAnimation animateIn="animate__fadeInUp" className={
                                    index % 2 ?
                                        "order-1 z-10 text-4xl font-bold relative w-[100px] h-[100px] flex justify-center items-center number-themes" :
                                        "order-2 z-10 text-4xl font-bold relative w-[100px] h-[100px] flex justify-center items-center number-themes"
                                }>
                                    <span className="relative z-20">{index + 1}</span>
                                    <img src={YellowIcon} alt="yellow-icon" className="w-full h-full absolute top-0 left-0 z-10" />
                                </ScrollAnimation>
                                <div className={
                                    index % 2 ?
                                        "order-2 w-[calc(100%-120px)] relative z-30" :
                                        "order-1 w-[calc(100%-120px)] relative z-30"
                                }>
                                    <ScrollAnimation animateIn="animate__fadeInUp">
                                        <h3 className="uppercase mb-1">{theme.title}</h3>
                                        <p>{theme.desc}</p>
                                    </ScrollAnimation>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {/*<div className="!bg-cover !bg-right-center" style={{background: "url(" + TopForm + ")"}}></div>*/}
                <div className="h-full"><img src={TopForm} className="object-cover h-full w-auto sm:rounded-l-2xl"
                                             alt="Теми HRWS"/></div>
            </div>
        </section>
    )
}

export default EventThemesBase;